<p>order-paid-modal works!</p>
